import React from 'react';

function NotFound() {
  return (
    <div id="pagenotfound">
      <img
        className="pagenotfound"
        src="https://site.manheim.com/wp-content/uploads/sites/2/Page%20images/404_blue_tire_tracks_3%20short.png"
        alt="page not found"
      />
      <h2>404 PAGE NOT FOUND</h2>
      <p>
        We are sorry, the page you are looking for does not exist.
        <br />
        If you need help, please email&nbsp;
        <a href="mailto:info@manheim.com">info@manheim.com</a>
        ,
        <br />
        or call&nbsp;
        <a href="tel:1-866-626-4326">1-866-626-4346</a>
        &nbsp;Mon-Sat, 8am-12am.
      </p>
    </div>
  );
}

export default NotFound;
